import store from "../store";

const state = () => ({
  filters: {
    // Make sure to update resetFilters
    completed: {
      users: [],
      statuses: null,
      campaigns: null,
      temperatures: null,
      dealProbabilityScore: null,
    },
  },
});

const getters = {
  filters(state) {
    return state.filters.completed;
  }
};

const mutations = {
  setOneFilter(state, [filterObject, filter, value]) {
    state.filters[filterObject][filter] = value;
    store.dispatch('updateUserAppFilter')
  },
  setUserFilters(state, filters) {
    // make sure this match the filters declared on state
    state.filters = filters
  },
  resetFilters(state, filterObject) {
    // Make sure to update state default
    state.filters[filterObject] = {
      users: [],
      statuses: null,
      campaigns: null,
      temperatures: null,
      dealProbabilityScore: null,
    };

    store.dispatch('updateUserAppFilter')
  },
};

const actions = {};

const CompletedStateStore = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};

export default CompletedStateStore;
